import React from 'react';

import { useFeatureContext } from '@dataswift/shared';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

import { useThemeContext } from '../../../styles/Provider';
import WideToggle from './WideToggle';
import ThinToggle from './ThinToggle';

const ThemeToggle: React.FC = () => {
  const theme = useTheme();
  const isWideScreen = useMediaQuery(theme.breakpoints.up('md'), { noSsr: true });
  const { setTheme } = useThemeContext();
  const flags = useFeatureContext();

  if (!flags.themeSwitch?.enabled) return null;

  const onSwitchTheme = () => {
    setTheme(theme.palette.type === 'dark' ? 'light' : 'dark');
  };

  return isWideScreen ? (
    <WideToggle onClick={onSwitchTheme} theme={theme} />
  ) : (
    <ThinToggle onClick={onSwitchTheme} theme={theme} />
  );
};

export default ThemeToggle;
